import { styled } from "@styles";
import { fadeIn } from "@styles/animations";

export const Container = styled("div", {
  position: "relative",

  background: "$neutral30",
  overflow: "hidden",
  cursor: "pointer",

  boxSizing: "border-box",

  img: {
    objectFit: "cover",
  },

  ".hover-content": {
    position: "relative",
    display: "none",
    width: "100%",
    height: "100%",
  },

  "&:hover": {
    ".hover-content": {
      display: "block",
    },
  },

  variants: {
    variant: {
      "x-small": {
        width: "2rem",
        minWidth: "2rem",
        height: "2rem",
        minHeight: "2rem",
        borderRadius: "$sm",
      },

      small: {
        width: "2.5rem",
        minWidth: "2.5rem",
        height: "2.5rem",
        minHeight: "2.5rem",
        borderRadius: "$sm",
      },

      "x-medium": {
        width: "4rem",
        minWidth: "4rem",
        height: "4rem",
        minHeight: "4rem",
        borderRadius: "$xlg",
      },

      medium: {
        width: "5.625rem",
        minWidth: "5.625rem",
        height: "5.625rem",
        minHeight: "5.625rem",
        borderRadius: "$xlg",
      },

      medium2: {
        width: "6.25rem",
        minWidth: "6.25rem",
        height: "6.25rem",
        minHeight: "6.25rem",
        borderRadius: "$xlg",
      },

      large: {
        width: "15.25rem",
        minWidth: "15.25rem",
        height: "15.25rem",
        minHeight: "15.25rem",
      },

      imgToken: {
        width: "$24px",
        height: "$24px",

        border: "1px solid $neutral20",
        borderRadius: "$rounded",
        position: "absolute",
        top: "-12px",
      },

      saleProduct: {
        width: "5.625rem",
        minWidth: "5.625rem",
        height: "5.625rem",
        minHeight: "5.625rem",
        borderRadius: "$md",
      },

      purchase: {
        width: "100%",
        height: "15.25rem",
        minHeight: "15.25rem",
        borderRadius: "$md",
      },
      extract: {
        width: "4.8125rem",
        minWidth: "4.8125rem",
        height: "4.8125rem",
        minHeight: "4.8125rem",
        border: "2px solid $neutral20",
        background: "transparent",
        borderRadius: "0.46875rem",
      },

      product: {
        width: "100%",
        height: "15.25rem",
        minHeight: "15.25rem",
        borderRadius: "$md $md 0 0",
      },

      orderBump: {
        width: "3.25rem",
        height: "3.25rem",
        minHeight: "3.25rem",
        borderRadius: "$sm",
        border: "1px solid $neutral20",
        "&:hover": {
          cursor: "default",
        },
      },
    },
    pointer: {
      noPointer: {
        cursor: "auto",
      },
    },

    fullWidth: {
      true: {
        width: "100%",
        minWidth: "100%",
      },
    },
  },

  defaultVariants: {
    variant: "small",
  },
});

export const EditImageHoverSmall = styled("button", {
  all: "unset",
  position: "absolute",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  width: "100%",
  height: "100%",

  background: "rgba(0, 0, 0, 0.2)",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,

  margin: "auto",

  zIndex: 2,
  animation: `${fadeIn} 0.3s ease-out`,

  svg: {
    width: "$20px",
    height: "$20px",
    color: "$neutral100",
  },
});

export const EditImageHoverLarge = styled("div", {
  all: "unset",
  position: "absolute",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 10,

  right: 0,
  left: 0,

  margin: "auto",
  padding: "$8px",

  backgroundColor: "rgba(255, 255, 255, 0.7)",
  color: "$blue40",
  fontSize: "$12px",
  fontWeight: "700",

  zIndex: 2,
  animation: `${fadeIn} 0.3s ease-out`,

  svg: {
    width: "$20px",
    height: "$20px",
  },

  variants: {
    bottom: {
      true: {
        bottom: 0,
      },
      false: {
        top: 0,
      },
    },

    description: {
      true: {
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        ".edit-image-text": {
          color: "#1F1F1F",
        },
      },
    },
  },
});
